import React from "react";
import { Integration } from "model/integration";
import { LeadAggregationCard } from "./card";
import { LeadAggregationModal } from "./modal";

interface Props {
	integration: Integration;
}

interface State {
	modalOpen: boolean;
	name?: string;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props);
		this.state = { modalOpen: false, name: props.integration.name };
	}

	public render() {
		const { integration } = this.props;
		const { modalOpen, name } = this.state;

		return (
			<>
				<LeadAggregationCard
					integration={integration}
					onViewIntegration={() => this.setState({ modalOpen: true })}
				/>
				<LeadAggregationModal
					open={modalOpen}
					onClose={() => this.setState({ modalOpen: false })}
					integration={integration}
					name={name}
					onNameChange={name => this.setState({ name })}
				/>
			</>
		);
	}

}

export const LeadAggregationIntegration = Component;
